import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-new-admin',
  templateUrl: './add-new-admin.component.html',
  styleUrls: ['./add-new-admin.component.scss']
})
export class AddNewAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
